import { WidgetType } from '@baserow/modules/dashboard/widgetTypes'

import GraficaWidget from '@extras_mg/components/GraficaWidget'
import GraficaWidgetSettings from '@extras_mg/components/GraficaWidgetSettings'

/**
 * Widget de grafica. Nombre propio (mg_grafica): no reemplaza a los de premium,
 * se suma a la lista. Los suyos siguen ahi con candado, pero este funciona.
 */
export class GraficaWidgetType extends WidgetType {
  static getType() {
    return 'mg_grafica'
  }

  get name() {
    return 'Grafica'
  }

  get component() {
    return GraficaWidget
  }

  get settingsComponent() {
    return GraficaWidgetSettings
  }

  isLoading(widget, data) {
    const id = widget.data_source_id
    return !(data[id] && Object.keys(data[id]).length !== 0)
  }
}
